module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/stamp-506c5035c5be2282032b3c3c23978ac7.svg";